module.exports = __webpack_public_path__ + "img/1-2.6d2d4519.png";